import { useSelector, } from 'react-redux';
import { IGlobalStore, IReducerStore, } from '@Store';

export const useVoiceQueueRouteOptions = (): IGlobalStore['voice_queue_route_options'] => {
  return useSelector((store: IReducerStore) => store.global.voice_queue_route_options);
};
